import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as JustAirLogo } from '../61520fa346e5a67b68fd5039_justair-logo-full-color-rgb-2.svg';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">
      <nav className="bg-white/80 backdrop-blur-md fixed w-full z-50 shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <JustAirLogo className="h-8 w-auto" />
            <h1 className="text-gray-900 text-lg font-semibold">Trucks Off Our Streets</h1>
          </div>
          <div className="text-gray-600 text-sm">{new Date().toLocaleDateString()}</div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-8">
        {/* Hero Section */}
        <div className="bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg p-8 border border-white/20 mb-8">
          <div className="text-center space-y-6">
            <h2 className="text-4xl font-bold text-gray-900">
              Trucks Off Our Streets
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Monitor and analyze truck activity with real-time air quality data to make informed decisions about environmental impact
            </p>
            <button
              onClick={() => navigate('/jobs')}
              className="mt-4 bg-gradient-to-br from-blue-500 to-blue-600 text-white px-8 py-3 rounded-xl text-lg font-semibold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg backdrop-blur-lg border border-white/10"
            >
              View Dashboard
            </button>
          </div>
        </div>

        {/* About Section */}
        <div className="bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg p-8 border border-white/20 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">About the Project</h2>
          <p className="text-gray-600 leading-relaxed">
            The Trucks Off Our Street (TOOS) Dashboard is a collaboration between the citywide TOOS Table, Southwest Detroit Environmental Vision, Southwest Detroit Community Benefits Coalition, and the University of Michigan. These partners are working with JustAir to reduce environmental triggers of asthma in Detroit by limiting diesel truck traffic in residential areas.
          </p>
        </div>

        {/* Questions Section */}
        <div className="bg-blue-500/10 backdrop-blur-xl rounded-2xl shadow-lg p-8 border border-blue-200/20 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Questions?</h2>
          <p className="text-gray-600">
            Contact <a href="mailto:info@sdevweb.org" className="text-blue-600 hover:text-blue-700">info@sdevweb.org</a> for more information or to get involved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
